
        export type PageLanguage = 'en' | 'de' | 'fr'
        const VALID_LANGUAGES: PageLanguage[] = ["en","de","fr"]

        export function isValidLanguage(language: string): language is PageLanguage {
          return VALID_LANGUAGES.includes(language as any)
        }
        